export default __webpack_public_path__ + "static/media/the-colin-and-samir-podcast@2x (1) 1.a3709fb9.png";